import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import azTranslation from "./locales/az/translation.json";
import enTranslation from "./locales/en/translation.json";
import esTranslation from "./locales/es/translation.json";
import deTranslation from "./locales/de/translation.json";

const resources = {
  az: { translation: azTranslation },
  en: { translation: enTranslation },
  es: { translation: esTranslation },
  de: { translation: deTranslation },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    supportedLngs: ["az", "en", "es", "de"],
    load: "languageOnly",
    fallbackLng: "en",
    debug: process.env.NODE_ENV === "development",
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["path", "localStorage", "cookie", "navigator"],
      caches: ["localStorage", "cookie"],
      lookupCookie: "preferred_language",
      lookupLocalStorage: "i18nextLng",
    },
  });

export default i18n;
